"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AtomLink = _interopRequireDefault(require("./AtomLink"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The TokenizedCards model module.
 * @module model/TokenizedCards
 * @version 3.0
 */
var TokenizedCards = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>TokenizedCards</code>.
   * @alias module:model/TokenizedCards
   */
  function TokenizedCards() {
    _classCallCheck(this, TokenizedCards);
    TokenizedCards.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(TokenizedCards, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>TokenizedCards</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/TokenizedCards} obj Optional instance to populate.
     * @return {module:model/TokenizedCards} The populated <code>TokenizedCards</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new TokenizedCards();
        if (data.hasOwnProperty('id')) {
          obj['id'] = _ApiClient["default"].convertToType(data['id'], 'Number');
        }
        if (data.hasOwnProperty('startDate')) {
          obj['startDate'] = _ApiClient["default"].convertToType(data['startDate'], 'String');
        }
        if (data.hasOwnProperty('expMonth')) {
          obj['expMonth'] = _ApiClient["default"].convertToType(data['expMonth'], 'String');
        }
        if (data.hasOwnProperty('expYear')) {
          obj['expYear'] = _ApiClient["default"].convertToType(data['expYear'], 'String');
        }
        if (data.hasOwnProperty('nameOnCard')) {
          obj['nameOnCard'] = _ApiClient["default"].convertToType(data['nameOnCard'], 'String');
        }
        if (data.hasOwnProperty('last4Digits')) {
          obj['last4Digits'] = _ApiClient["default"].convertToType(data['last4Digits'], 'String');
        }
        if (data.hasOwnProperty('cardToken')) {
          obj['cardToken'] = _ApiClient["default"].convertToType(data['cardToken'], 'String');
        }
        if (data.hasOwnProperty('cardType')) {
          obj['cardType'] = _ApiClient["default"].convertToType(data['cardType'], 'String');
        }
        if (data.hasOwnProperty('_links')) {
          obj['_links'] = _ApiClient["default"].convertToType(data['_links'], [_AtomLink["default"]]);
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>TokenizedCards</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>TokenizedCards</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['startDate'] && !(typeof data['startDate'] === 'string' || data['startDate'] instanceof String)) {
        throw new Error("Expected the field `startDate` to be a primitive type in the JSON string but got " + data['startDate']);
      }
      // ensure the json data is a string
      if (data['expMonth'] && !(typeof data['expMonth'] === 'string' || data['expMonth'] instanceof String)) {
        throw new Error("Expected the field `expMonth` to be a primitive type in the JSON string but got " + data['expMonth']);
      }
      // ensure the json data is a string
      if (data['expYear'] && !(typeof data['expYear'] === 'string' || data['expYear'] instanceof String)) {
        throw new Error("Expected the field `expYear` to be a primitive type in the JSON string but got " + data['expYear']);
      }
      // ensure the json data is a string
      if (data['nameOnCard'] && !(typeof data['nameOnCard'] === 'string' || data['nameOnCard'] instanceof String)) {
        throw new Error("Expected the field `nameOnCard` to be a primitive type in the JSON string but got " + data['nameOnCard']);
      }
      // ensure the json data is a string
      if (data['last4Digits'] && !(typeof data['last4Digits'] === 'string' || data['last4Digits'] instanceof String)) {
        throw new Error("Expected the field `last4Digits` to be a primitive type in the JSON string but got " + data['last4Digits']);
      }
      // ensure the json data is a string
      if (data['cardToken'] && !(typeof data['cardToken'] === 'string' || data['cardToken'] instanceof String)) {
        throw new Error("Expected the field `cardToken` to be a primitive type in the JSON string but got " + data['cardToken']);
      }
      // ensure the json data is a string
      if (data['cardType'] && !(typeof data['cardType'] === 'string' || data['cardType'] instanceof String)) {
        throw new Error("Expected the field `cardType` to be a primitive type in the JSON string but got " + data['cardType']);
      }
      if (data['_links']) {
        // data not null
        // ensure the json data is an array
        if (!Array.isArray(data['_links'])) {
          throw new Error("Expected the field `_links` to be an array in the JSON data but got " + data['_links']);
        }
        // validate the optional field `_links` (array)
        var _iterator = _createForOfIteratorHelper(data['_links']),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _AtomLink["default"].validateJSON(item);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        ;
      }
      return true;
    }
  }]);
}();
/**
 * @member {Number} id
 */
TokenizedCards.prototype['id'] = undefined;

/**
 * @member {String} startDate
 */
TokenizedCards.prototype['startDate'] = undefined;

/**
 * @member {String} expMonth
 */
TokenizedCards.prototype['expMonth'] = undefined;

/**
 * @member {String} expYear
 */
TokenizedCards.prototype['expYear'] = undefined;

/**
 * @member {String} nameOnCard
 */
TokenizedCards.prototype['nameOnCard'] = undefined;

/**
 * @member {String} last4Digits
 */
TokenizedCards.prototype['last4Digits'] = undefined;

/**
 * @member {String} cardToken
 */
TokenizedCards.prototype['cardToken'] = undefined;

/**
 * @member {String} cardType
 */
TokenizedCards.prototype['cardType'] = undefined;

/**
 * @member {Array.<module:model/AtomLink>} _links
 */
TokenizedCards.prototype['_links'] = undefined;
var _default = exports["default"] = TokenizedCards;